import { render, staticRenderFns } from "./pointProductedit.vue?vue&type=template&id=78d00f1c&scoped=true&"
import script from "./pointProductedit.vue?vue&type=script&lang=js&"
export * from "./pointProductedit.vue?vue&type=script&lang=js&"
import style0 from "./pointProductedit.vue?vue&type=style&index=0&id=78d00f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d00f1c",
  null
  
)

export default component.exports